export default __webpack_public_path__ + "a1412a0258ccc139f77eb1755d920831.webp";